module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAIAAAC2BqGFAAABW0lEQVR42uzdvy4EQRzAcTs3FHIU618klyuISBQnGv0lQqtSeAbxBJ5jn0Cl0SoU9KpVSFQSkSiWhgfQD+Vg2c+3nGJ+l09uf1tunLmsJvT9BQSgQQs0aNACDVqgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIH+J8VfmbozNzwd7SWHx3fXZ8/3GaccDTdPVreTw92b8/qt6Qp0LMJ0SEdPhsyP11TofZ7SK4LVYUcLNGiBBg1aoEELNGjQAg1aoEGDFmjQAv3jxfb8lIOltVF/PuOFW7MLoL9oXA7G5cDqEGjQAt3hl2H1WF+9PmW8cH9x5XB5HXTa7fvLRfOQ8cKNfml12NECDVqgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdB/tsJXlP2jQQs0aNACDVqgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIEGLdAt7CMAAP//YVUdj6plgjgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-huffington-post.png
// module id = JDec
// module chunks = 0